(function () {
    'use strict';

    angular.module('app').controller('JobFinancialDetailsModalController', JobFinancialDetailsModalController);
    JobFinancialDetailsModalController.$inject = [
        'data',
        '$uibModalInstance',
        'FleetService',
        '$filter',
        'Shipments',
        'AdminPermissionService',
        'PermissionHelpers',
        '$rootScope'
    ];

    function JobFinancialDetailsModalController(
        data,
        $uibModalInstance,
        FleetService,
        $filter,
        Shipments,
        AdminPermissionService,
        PermissionHelpers,
        $rootScope
    ) {
        const vm = this;
        vm.closeModal = closeModal;

        init();
        function init() {
            setIsHideRatesEngine();
            if (data.actualShippingCost) {
                vm.actualFinancialDetails = angular.copy(data.actualShippingCost);
                vm.actualFinancialDetails.currency = data.currency;
                vm.actualFinancialDetails.baseRate = data.actualShippingCost.sellPrice;
                vm.actualFinancialDetails.totalExTax = $filter('bbaCurrency')(data.amount, data.currency);
                vm.actualFinancialDetails.cost = $filter('bbaCurrency')(data.actualShippingCost.cost, data.currency);
                vm.actualFinancialDetails.duties = $filter('bbaCurrency')(data.actualShippingCost.duties, data.currency);
                vm.actualFinancialDetails.isShipmentDetails = true;
                vm.actualFinancialDetails.promoDetails = data.promoDetails
                vm.actualFinancialDetails.actualDuration = angular.getObjVal(data, 'timeBasedRateDetail.actualDuration') || null;
                vm.actualFinancialDetails.waitingDuration = angular.getObjVal(data, 'timeBasedRateDetail.waitingDuration') || null;
            }

            if (data.quotedShippingCost) {
                vm.quotedFinancialDetails = angular.copy(data.quotedShippingCost);
                vm.quotedFinancialDetails.currency = data.currency;
                vm.quotedFinancialDetails.baseRate = data.quotedShippingCost.sellPrice;

                const financialData = angular.copy(data.quotedShippingCost);
                financialData.amount = angular.copy(data.amount);
                financialData.currency = angular.copy(data.currency);
                financialData.timeBasedRateDetail = angular.copy(data.timeBasedRateDetail);
                financialData.actualAmountUpdated = angular.copy(data.actualAmountUpdated);

                const formattedData = Shipments.getShipmentCostFormattedForFinalAndQuoted(financialData);
                vm.quotedFinancialDetails.totalExTax = formattedData.amountFormatted;
                vm.quotedFinancialDetails.cost = formattedData.costFormatted;
                vm.quotedFinancialDetails.duties = formattedData.dutiesFormatted;
                vm.quotedFinancialDetails.promoDetails = data.promoDetails
                vm.quotedFinancialDetails.isShipmentDetails = true;
            }

            if (data.actualJobFinancials) {
                data.actualJobFinancials.timeBased = data.timeBased;
                vm.actualFinancialDetails = mapData(data.actualJobFinancials, false);
                vm.actualFinancialDetails.baseRate = data.actualJobFinancials.baseRate;
                vm.actualFinancialDetails.isShipmentDetails = false;
            }

            if (data.quotedJobFinancials) {
                data.quotedJobFinancials.timeBased = data.timeBased;

                vm.quotedFinancialDetails = mapData(data.quotedJobFinancials);
                vm.quotedFinancialDetails.baseRate = data.quotedJobFinancials.baseRate;
                vm.quotedFinancialDetails.isShipmentDetails = false;
            }

            if (vm.quotedFinancialDetails != null) {
                vm.quotedFinancialDetails.serviceProfile = data.serviceProfile;
            }

            if (vm.actualFinancialDetails != null) {
                vm.actualFinancialDetails.serviceProfile = data.serviceProfile;
            }
        }

        function setIsHideRatesEngine() {
            AdminPermissionService.AdminCurrentUser.getAdminUserDetails(success => {
                const moduleAccess = [];
                success.content.forEach(user => {
                    user.modules.forEach(module => {
                        moduleAccess.push(module.name);
                    });
                });
                vm.isHideRatesEngine = PermissionHelpers.isHideRatesEngine(moduleAccess);
            }, error => { }, $rootScope.GlobalProfile.id);
        }

        function mapData(data, formatCost = true) {
            if (data) {
                const tmpData = {};
                if (formatCost) {
                    tmpData.cost = FleetService.Jobs.getJobCostFormattedForFinalAndQuotedPricing(data).costPrice;
                    tmpData.totalExTax = FleetService.Jobs.getJobCostFormattedForFinalAndQuotedPricing(data).shipmentRate;
                    tmpData.taxes = FleetService.Jobs.getJobCostFormattedForFinalAndQuotedPricing(data).tax;
                    tmpData.duties = FleetService.Jobs.getJobCostFormattedForFinalAndQuotedPricing(data).duties;
                } else {
                    tmpData.cost = $filter('bbaCurrency')(data.totalCostPrice, data.currency);
                    tmpData.totalExTax = $filter('bbaCurrency')(data.shipmentRate, data.currency);
                    tmpData.taxes = $filter('bbaCurrency')(data.taxes, data.currency);
                    tmpData.duties = $filter('bbaCurrency')(data.duties, data.currency);
                }


                tmpData.driverCommissionFixed = data.driverCommissionFixed;
                tmpData.driverCommissionPercentage = data.driverCommissionPercentage;
                tmpData.driverCommissionPercentageValue = data.driverCommissionPercentageValue;
                tmpData.percentFuel = data.fuelPercentage;
                tmpData.percentMargin = data.marginPercentage
                tmpData.percentValueFuel = data.fuelPercentageValue;
                tmpData.percentValueMargin = data.marginPercentageValue;
                tmpData.promoDetails = data.promoDetails;
                tmpData.surchargeDetails = data.surchargeDetails;
                tmpData.valueFuel = data.fuelFixed;
                tmpData.valueMargin = data.marginFixed;
                tmpData.currency = data.currency;
                tmpData.baseRate = data.baseRate;
                tmpData.waitingDuration = angular.getObjVal(data, 'timeBasedRateDetail.waitingDuration') ? data.timeBasedRateDetail.waitingDuration : null;
                return tmpData;
            }
            return null;
        }

        function closeModal() {
            $uibModalInstance.dismiss();
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/modal/JobFinancialDetailsModalController.js